import { MINIMO_DA_SENHA } from '../auth/recuperacaoDeSenha'

// Spec 2026-10-06: "Trocar senha" no Meu perfil. Minimo 8 = o mesmo do convite
// (MINIMO_DA_SENHA em auth/recuperacaoDeSenha.ts; decisao dela 18/10).
// Decisao dela 06/10: pede a senha ATUAL (celular desbloqueado nao troca sozinho).
export function validarNovaSenha(nova: string, repetida: string, atual: string): string | null {
  if (atual === '') return 'Digite a senha atual.'
  if (nova.length < MINIMO_DA_SENHA) return `A senha precisa ter pelo menos ${MINIMO_DA_SENHA} caracteres.`
  if (nova !== repetida) return 'As duas senhas não são iguais.'
  return null
}

// Revisao final: so credencial invalida e "senha errada"; sem internet, limite
// de tentativas ou servidor parado nao podem dizer que a senha nao confere.
export type ResultadoDaConferencia = 'ok' | 'errada' | 'sem-conexao'
export function resultadoDaConferencia(erro: { code?: string; status?: number } | null): ResultadoDaConferencia {
  if (!erro) return 'ok'
  return erro.code === 'invalid_credentials' ? 'errada' : 'sem-conexao'
}
